import { render, staticRenderFns } from "./FinalizacaoMensagensComprador.vue?vue&type=template&id=29609441"
import script from "./FinalizacaoMensagensComprador.vue?vue&type=script&lang=js"
export * from "./FinalizacaoMensagensComprador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports